module.exports = __webpack_public_path__ + "media/images/emblems/Heremence-coat_of_arms-6cd6ec69879b1f5e2130d1fb40032247.svg";